export const ADDITIONAL_APPLICANT_PARTICULARS = 'additional-applicant-particulars';
export const ADDITIONAL_APPLICANT_ADDRESS = 'additional-applicant-address';
export const PRINTING_PRESS_PARTICULARS = 'printing-press-particulars';
export const PRINTING_PRESS_OPERATING_ADDRESS = 'printing-press-operating-address';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_PPL_APPLICATION = [
    {
        sectionID: ADDITIONAL_APPLICANT_PARTICULARS,
        sectionName: 'Additional Applicant Particulars',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'date-of-birth',
                label: 'Date of Birth',
                type: 'text'
            },
            {
                id: 'nationality',
                label: 'Nationality',
                type: 'text'
            },
            // {
            //     id: 'passport-number',
            //     label: 'Passport Number',
            //     type: 'text'
            // },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'telephone-number',
                label: 'Telephone Number',
                type: 'text'
            },
            {
                id: 'mobile-number',
                label: 'Mobile Number',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ADDITIONAL_APPLICANT_ADDRESS,
        sectionName: 'Additional Applicant Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: PRINTING_PRESS_PARTICULARS,
        sectionName: 'Printing Press Particulars',
        fieldList: [
            {
                id: 'operating-address-is-the-same-as-acra-registered-address',
                label: 'Operating Address is the same as ACRA Registered Address',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: PRINTING_PRESS_OPERATING_ADDRESS,
        sectionName: 'Printing Press Operating Address',
        fieldList: [
            {
                id: 'name-of-printing-press',
                label: 'Name of Printing Press',
                type: 'text',
                span: 12
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                span: 12
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text'
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                span: 12
            },
            {
                id: 'telephone-number',
                label: 'Telephone Number',
                type: 'text'
            },
            {
                id: 'mobile-number',
                label: 'Mobile Number',
                type: 'text'
            },
            {
                id: 'number-of-machines',
                label: 'Number of Machines',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
